"use strict";

require("core-js/modules/es6.regexp.search");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.regexp.replace");

var _slicedToArray = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/slicedToArray");

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useHash = void 0;

var react_1 = __importDefault(require("react"));

var react_router_dom_1 = require("react-router-dom");

function useHash() {
  var _a;

  var _react_1$default$useS = react_1["default"].useState((_a = window.location.hash) === null || _a === void 0 ? void 0 : _a.slice(1)),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      hash = _react_1$default$useS2[0],
      _setHash = _react_1$default$useS2[1];

  var location = (0, react_router_dom_1.useLocation)();

  function setHash(newHash) {
    _setHash(newHash);

    var historyMethod = window.location.hash ? 'pushState' : 'replaceState';
    window.history[historyMethod]({}, '', window.location.toString().replace(window.location.hash, '') + (newHash ? "#".concat(newHash) : ''));
  } // Also listen for changes to react-router-dom's location.


  react_1["default"].useEffect(function () {
    var _a;

    var newHash = (_a = location.hash) === null || _a === void 0 ? void 0 : _a.slice(1);

    _setHash(newHash);
  }, [location.search, location.hash, location.pathname]);
  return [hash, setHash];
}

exports.useHash = useHash;